import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m14.25 9.755 2.25 2.25-2.25 2.25m-4.5 0-2.25-2.25 2.25-2.25M6 20.255h12a2.25 2.25 0 0 0 2.25-2.25v-12A2.25 2.25 0 0 0 18 3.755H6a2.25 2.25 0 0 0-2.25 2.25v12A2.25 2.25 0 0 0 6 20.255"
    }, null, -1)
  ])))
}
export default { render: render }